import axios from 'axios'

import { getTariffParams } from '../model/tariff.model'

import { Tariff } from '~/basket/model/lines/tariff/tariff.model'

export default class TariffService {
  constructor(private host: string) {}

  fetchTariffs(params: getTariffParams): Promise<Tariff[]> {
    return axios
      .get(`${this.host}/tariffs/v1/masmovil/tariffs`, { params: { ...params } })
      .then((response) => response.data)
  }
}
